// extracted by mini-css-extract-plugin
module.exports = {"component":"LicensePlateInput_component__Tzshr","block":"LicensePlateInput_block__qnud3","selected":"LicensePlateInput_selected__rl0d5"};